import data from '@emoji-mart/data/sets/14/native.json' with { type: 'json' }
import { init } from 'emoji-mart'

// TODO emoji: remove this when backend returns unicode emoji
export const initEmojiLib = () => {
  // will noop if already initialized
  init({ data })
}
